import { render, staticRenderFns } from "./ChooseColumn.vue?vue&type=template&id=4637d274&"
import script from "./ChooseColumn.vue?vue&type=script&lang=js&"
export * from "./ChooseColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports